// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const FindingSeveritySchema = z.enum(['Critical','High','Medium','Low','Info'] as const);

export type FindingSeverityType = `${z.infer<typeof FindingSeveritySchema>}`

export default FindingSeveritySchema;
